import { render, staticRenderFns } from "./wxsubscribe.vue?vue&type=template&id=41949d3b&scoped=true&"
import script from "./wxsubscribe.vue?vue&type=script&lang=js&"
export * from "./wxsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./wxsubscribe.vue?vue&type=style&index=0&id=41949d3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41949d3b",
  null
  
)

export default component.exports